import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { DirectionProvider } from "@radix-ui/react-direction";
import { I18nProvider, useI18n } from "./lib/i18n";
import { SiteProvider } from "./lib/site";
import { CustomerProvider } from "./lib/customer";
import Account, { InvestorPortal } from "./pages/Account";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Listings from "./pages/Listings";
import PropertyDetail from "./pages/PropertyDetail";
import Developments from "./pages/Developments";
import ProjectDetail from "./pages/ProjectDetail";
import { News, ArticleDetail } from "./pages/News";
import { ContentPage, Services, Investment, Contact, ScheduleViewing } from "./pages/ContentPages";
import NotFound, { Favorites } from "./pages/NotFound";
import AdminApp from "./admin/AdminApp";
import ErrorBoundary from "./components/ErrorBoundary";

function AppRoutes() {
  const { dir } = useI18n();
  return (
    <DirectionProvider dir={dir}>
      <BrowserRouter>
        <Routes>
          <Route path="/admin/*" element={<AdminApp />} />
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<ContentPage slug="about" />} />
            <Route path="vision-mission" element={<ContentPage slug="vision-mission" />} />
            <Route path="services" element={<Services />} />
            <Route path="investment" element={<Investment />} />
            <Route path="properties" element={<Listings kind="all" />} />
            <Route path="properties/for-sale" element={<Listings key="sale" kind="sale" preset={{ purpose: "sale" }} />} />
            <Route path="properties/for-rent" element={<Listings key="rent" kind="rent" preset={{ purpose: "rent" }} />} />
            <Route path="properties/:slug" element={<PropertyDetail />} />
            <Route path="residential" element={<Listings key="res" kind="residential" preset={{ category: "residential" }} />} />
            <Route path="commercial" element={<Listings key="com" kind="commercial" preset={{ category: "commercial" }} />} />
            <Route path="land-investment" element={<Listings key="land" kind="land" preset={{ segment: "land_investment" }} />} />
            <Route path="developments" element={<Developments />} />
            <Route path="developments/:slug" element={<ProjectDetail />} />
            <Route path="news" element={<News />} />
            <Route path="news/:slug" element={<ArticleDetail />} />
            <Route path="contact" element={<Contact />} />
            <Route path="schedule-viewing" element={<ScheduleViewing />} />
            <Route path="favorites" element={<Favorites />} />
            <Route path="account" element={<Account />} />
            <Route path="investor-portal" element={<InvestorPortal />} />
            <Route path="privacy" element={<ContentPage key="privacy" slug="privacy" />} />
            <Route path="terms" element={<ContentPage key="terms" slug="terms" />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </DirectionProvider>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <I18nProvider>
        <SiteProvider>
          <CustomerProvider>
          <ErrorBoundary><AppRoutes /></ErrorBoundary>
          </CustomerProvider>
        </SiteProvider>
      </I18nProvider>
    </HelmetProvider>
  );
}
